import { autoinject, transient } from "aurelia-framework";
import { DialogClientService as CommonDialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { EntityValidationsService, ClientSideValidator } from "../../../../../../client-validation-system/validations-service";
import { ValidationActivation, ValidationTypeEnum } from "../../../../../../client-validation-system/validations.models";
import { SubtasksService } from "../../../../../../services/subtasks/subtasks.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { EmailRecipientTypeEnum } from "../../../../../../models/vetting/vetting.models";
import { UserClientService } from "../../../../../../services/authentication/user-client.service";
import { AttachmentFile } from "../../../../../../models/uploader/attachmentFile";

@autoinject
@transient()
export class AddCorrespondenceDialog {
    correspondenceEmails: { email: string, emailRecipientTypeId: EmailRecipientTypeEnum.To }[] = [];
    correspondenceMessage: string;
    validatorMessages: ClientSideValidator;
    validatorEmails: ClientSideValidator;
    subtaskCorrespondenceId: number;
    entityId: number;
    entityTypeId: number;
    warning: number;
    orderGuid: string;
    isPriority: boolean;
    isCloseout: boolean;
    isPSC: boolean;
    files: AttachmentFile[];
    onSubtaskAdded: (() => void);
    showWarningSection: boolean = false;
    showAttachmentTypes: boolean = false;

    constructor(private dialogClientService: DialogClientService, private commonDialogClientService: CommonDialogClientService,
        private entityValidationsService: EntityValidationsService, private subtasksService: SubtasksService,
        protected notificationClientService: NotificationClientService, private userClientService: UserClientService) { }

    async activate(params) {
        this.onSubtaskAdded = params.onSubtaskAdded;
        this.warning = params.warning;
        this.orderGuid = params.orderGuid;
        this.isPriority = params.isPriority;
        this.isCloseout = params.isCloseout;
        this.entityId = params.entityId;
        this.entityTypeId = params.entityTypeId;
        this.isPSC = params.isPSC;
        this.showAttachmentTypes = params.showAttachmentTypes ? params.showAttachmentTypes : false;

        if (!this.correspondenceEmails)
            this.correspondenceEmails = [];

        if (this.userClientService && this.userClientService.currentUser && this.userClientService.currentUser.email)
            this.correspondenceEmails.push({ email: this.userClientService.currentUser.email, emailRecipientTypeId: EmailRecipientTypeEnum.To });

        if (this.warning) {
            this.showWarningSection = true;
        }

        await this.onActivate(params);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onActivate(params: any): void {}

    attached() {

        const rulesHolderEmails = {
            activation: ValidationActivation.Always,
            entityName: "correspondenceEmails",
            isCollection: true,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Correspondence Email is required",
                parameters: null, property: "email",
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Correspondence Email is not in correct format",
                parameters: null, property: "email",
                validationType: ValidationTypeEnum.Email
            }]
        }

        const rulesHolderMessage = {
            activation: ValidationActivation.Always,
            entityName: "Correspondence Message",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Correspondence Message is required",
                parameters: null, property: "correspondenceMessage",
                validationType: ValidationTypeEnum.Required
            }]
        };

        this.validatorMessages = this.entityValidationsService.getValidator(this, rulesHolderMessage);
        this.validatorEmails = this.entityValidationsService.getValidator(this.correspondenceEmails, rulesHolderEmails);
    }

    close() {
        this.dialogClientService.hide();
        this.commonDialogClientService.hide(true);
    }

    public validateOnSubmit(): boolean {
        return true;
    }

    public async submit() {
        try {
            if (this.correspondenceMessage && !$(this.correspondenceMessage).get(0).innerText.trim()) {
                this.correspondenceMessage = "";
            }

            const result2 = await this.validatorMessages.validate();

            if (!result2.valid)
                return;

            if (!this.validateOnSubmit())
                return;

            await this.addSubtask(true);
            if (this.onSubtaskAdded)
                this.onSubtaskAdded();
            this.correspondenceMessage = "";
            this.subtaskCorrespondenceId = null;
            this.files = [];

            this.close();
            this.notificationClientService.show("Contact RightShip Operations", "Thank you for your message. You will receive an email when RightShip respond back to you.", NotificationType.Success);
        } catch {
            this.notificationClientService.show("Contact RightShip Operations", "Failed to send message.", NotificationType.Error);
        }
    }

    async addSubtask(submit: boolean) {
        const snippet = this.isCloseout ? "Close Out Submitted" : "Customer Correspondence";
        return await this.subtasksService.addSubtask({
            entityId: this.entityId,
            entityTypeId: this.entityTypeId,
            emails: this.correspondenceEmails.map(x => {
                return { email: x.email, emailRecipientTypeId: x.emailRecipientTypeId }
            }),
            orderGuid: this.orderGuid,
            isPriority: this.isPriority,
            isInternal: false,
            skipInvitation: true,
            isCustomerRFI: true,
            changeStatusToPendingReview: true,
            changeStatusToAwaitingResponse: false,
            message: this.correspondenceMessage,
            resendEmail: false,
            comment: "",
            attachments: [],
            files: this.getAttachmentTypes(),
            statusSnippet: snippet,
            name: `${snippet}<br/>User: ${this.userClientService.currentUser.userName}<br/>Email: ${this.userClientService.currentUser.email}`,
            submit: submit,
            subtaskId: null,
            subtaskTypes: [],
            subtaskCorrespondenceId: this.subtaskCorrespondenceId,
            linkedEntityIds: [],
            linkedEntityTypeId: null,
            dataSourceId: 0
        });
    }
    removeEmail(index: number) {
        if (this.correspondenceEmails.length == 0)
            return;

        this.correspondenceEmails.splice(index, 1);
    }

    addEmail() {
        if (!this.correspondenceEmails) {
            this.correspondenceEmails = [];
        }

        this.correspondenceEmails.push({ email: "", emailRecipientTypeId: EmailRecipientTypeEnum.To });
    }

    getAttachmentTypes() {
        if (this.files && this.files.length > 0) {
            const attachmentFiles = this.files.map(c => {
                return { attachementTypeId: c.attachmentTypeId, file: c as File }
            });
            return attachmentFiles;
        }

        return [];
    }
}